import $ from 'jquery';
import fetch from 'utils/fetch';
import { error as toastError, success as toastSuccess } from 'plugins/toastr';
import { displayLoader, hideLoader } from 'plugins/loader';
import { bindModal } from '../common/modals/index';

export function contract(ctx) {
  $('.contract.submit.button').on('click', evt => {
    $(':submit').click();
  });

  $('.tech_doc_info.help').popup({
    popup: '.tech_doc_info.popup',
    on: 'hover',
    position: 'right center',
    lastResort: 'top left',
    offset: 0,
  });

  contractFileTableHandler(ctx);
  contractToggleAutomaticRenewal(ctx);

  var acc = $('#accordion-title');
  acc[0].addEventListener('click', function() {
    this.classList.toggle('active');

    var panel = this.nextElementSibling;
    if (panel.style.display === 'block') {
      panel.style.display = 'none';
    } else {
      panel.style.display = 'block';
    }
  });
}

function contractToggleAutomaticRenewal(ctx) {
  const url = $('#automaticRenewal').data('url')
    ? $('#automaticRenewal').data('url')
    : '';

  $('#automaticRenewal').on('change', evt => {
    fetch(url, {
      method: 'POST',
    }).then(res => {
      hideLoader();
      return res.text();
    });
  });
}

function contractFileTableHandler(ctx) {
  $('.contract.upload.button').on('click', evt => {
    $('#uploadContractInput').trigger('click');
  });

  const url = $('#uploadContractInput').data('url')
    ? $('#uploadContractInput').data('url')
    : '';

  $('#uploadContractInput').on('change', evt => {
    const file = evt.target.files[0];

    if (file) {
      let fd = new FormData();
      fd.append('contract', file);
      displayLoader();
      fetch(url, {
        method: 'POST',
        body: fd,
      })
        .then(res => {
          toastSuccess('Le fichier a été téléchargé avec succès');
          hideLoader();
          return res.text();
        })
        .then(refreshContractTable, error => {
          hideLoader();
          toastError('Une erreur est survenue pendant la sauvegarde.');
        });
    }
  });

  enableDeleteButtons();
  handleOrganizeLink();
  handleFileVisibility();
  bindModal();
}

function handleOrganizeLink() {
  const $button = $('#organize-btn');

  $button.on('click', evt => {
    evt.preventDefault();

    const url = $button.attr('href');
    const ref = $('#reference').val();
    const start = $('#start_date').val();
    const end = $('#end_date').val();
    const autoRenewal = $('#automatic_renewal').checkbox('is checked')
      ? 'on'
      : 'off';

    window.location.href =
      url +
      '?reference=' +
      ref +
      '&start_date=' +
      start +
      '&end_date=' +
      end +
      '&automatic_renewal=' +
      autoRenewal;
  });
}

function handleFileVisibility() {
  $('.contractRow .ui.checkbox.checked').checkbox('set checked');

  $('.contractRow input[name="isCustomerAccessAllowed"]').on('change', evt => {
    $(evt.target)
      .closest('form')
      .submit();
  });
  $('.contractRow input[name="isTechAccessAllowed"]').on('change', evt => {
    $(evt.target)
      .closest('form')
      .submit();
  });
}

export function refreshContractTable(content) {
  let contractList = document.getElementById('contractList');
  contractList.innerHTML = content;

  enableDeleteButtons();
  handleFileVisibility();
}

export function enableDeleteButtons() {
  $('.button.deleteContract').on('click', evt => {
    evt.preventDefault();

    const $button = $(evt.currentTarget);
    const url = $button.attr('data-url');

    if (url) {
      $('.modal.delete')
        .modal({
          onApprove: element => {
            displayLoader();
            fetch(url, { method: 'DELETE' })
              .then(res => {
                $('.modal.delete').modal('hide');
                hideLoader();
                return res.text();
              })
              .then(
                res => {
                  toastSuccess("L'élément a été supprimé");
                  refreshContractTable(res);
                },
                error => {
                  hideLoader();
                  toastError('Une erreur est survenue pendant la suppression.');
                }
              );
            return false;
          },
        })
        .modal('show');
    }
  });
}

export const paymentConditionOptions = [
  // TODO fetch as referential
  {
    text: '30 jours après émission',
    value: '30_DAYS',
    inputDateDisabled: true,
    numberOfDays: 30,
    endOfMonth: false,
  },
  {
    text: '60 jours après émission',
    value: '60_DAYS',
    inputDateDisabled: true,
    numberOfDays: 60,
    endOfMonth: false,
  },
  {
    text: '30 jours fin du mois après émission',
    value: '30_DAYS_END_MONTH',
    inputDateDisabled: true,
    numberOfDays: 30,
    endOfMonth: true,
  },
  {
    text: '45 jours fin du mois après émission',
    value: '45_DAYS_END_MONTH',
    inputDateDisabled: true,
    numberOfDays: 45,
    endOfMonth: true,
  },
  {
    text: 'Personnalisées',
    value: 'CUSTOM',
    inputDateDisabled: false,
    numberOfDays: 0,
    endOfMonth: false,
  },
];

export const invoicePaymentFrequencyOptions = [
  // TODO fetch as referential
  {
    text: 'En une fois',
    value: 1,
  },
  {
    text: 'En 4 fois',
    value: 4,
  },
  {
    text: 'En 12 fois',
    value: 12,
  },
];



// WEBPACK FOOTER //
// ./src/modules/saas/aast/case-contract/index.js